import React from 'react';
import PropTypes from 'prop-types';
import { getSeoData } from '../../utils/helpers';
import { ItemCreationForm } from '../../components/ItemCreationForm';
import Layout from '../../components/Layout/Layout';

const NewItem = ({ returnURL }) => <ItemCreationForm returnURL={returnURL} />;

NewItem.propTypes = {
  returnURL: PropTypes.string
};

NewItem.getInitialProps = async ({ apolloClient, asPath, req }) => {
  const seoData = await getSeoData(apolloClient, asPath, req);

  let returnURL = '';

  if (req && req.get) {
    returnURL = `${req.protocol}://${req.get('Host')}${asPath}`;
  } else if (typeof window !== 'undefined') {
    returnURL = window.location.href;
  }

  return {
    seoData,
    returnURL
  };
};

NewItem.getLayout = page => (
  <Layout isShowFooter={false} isBottomNavigation={false}>
    {page}
  </Layout>
);

export default NewItem;
